import { Component, Input, OnChanges, ChangeDetectorRef, SimpleChanges, inject } from '@angular/core';
import { Chart, ChartType, ChartDataset} from 'chart.js';
import { NWMChartSettings } from './NWMChartSettings';
import { tooltipType } from "app/components/NWMCharts/NWMCharts.module";
import { CartesianScaleOptions } from 'chart.js/auto';
import { APIService } from 'app/services/api.service';
import { BaseChartDirective } from 'ng2-charts';

@Component({
    selector: 'PGFChart',
    templateUrl: './nwmchart.component.html',
    styleUrls: ['./nwmchart.component.scss'],
    imports: [BaseChartDirective]
})

export class PGFChartComponent implements OnChanges {
  private api = inject(APIService);
  private ref = inject(ChangeDetectorRef);

  @Input() data:number[][] = [];
  @Input() chartLabels: string[] = [];

  public chartData: ChartDataset[] = [];
  public chartType: ChartType = 'bar';
  public chartLegend = false;
  public tooltip: tooltipType = {visible:false, rows:[]};
  public chartSettings: NWMChartSettings;
  public width = 500;
  public height = window.innerWidth > 575 ? 150 : 250;
  public valuationDate = '';
  public dataLoaded = true;

  constructor() {
    this.chartSettings = new NWMChartSettings();
    (this.chartSettings.options.scales!['x']! as CartesianScaleOptions).stacked! = false;
    (this.chartSettings.options.scales!['y']! as CartesianScaleOptions).stacked! = false;
    this.chartSettings.options.scales!['y']!.ticks!.callback = (value, index, ticks) => 
      this.chartSettings.getYAxisLabelToShow(ticks.map(t=>t.value), value as number);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.tooltip.visible = false;
    this.chartSettings.options.plugins = {tooltip:{enabled: false, external: (a)=>this.customTooltip(a.chart)}};
    Object.assign(this.chartSettings.options.scales!['x']!.ticks!, {autoSkip: true, maxRotation: 90, minRotation: 0,padding:7});
    if (Object.prototype.hasOwnProperty.call(changes,'data')) {

      this.chartData[0] = {data: this.data[0], backgroundColor: '#2a3a69', barPercentage:this.chartData.length === 1 ? .7: 1};
      if (this.data[1]) {
        this.chartData[1] = {data:this.data[1], backgroundColor: '#93a8a3', barPercentage:1}
      }
    }
  }

  customTooltip(chart: Chart): void {
    const tooltipModel = chart.tooltip!;
    this.tooltip.visible = tooltipModel.opacity !== 0;
    if (tooltipModel.body) {
      const i = tooltipModel.dataPoints[0].dataIndex;
      if (this.chartData.length === 1) {
        this.tooltip.rows = [
          { key: 'Year:', value: tooltipModel.title[0] },
          { key: 'Grants: ', value:  this.api.formatCurrency(this.chartData[0].data[i] as number) },
        ];
      } else {
        this.tooltip.rows = [
          { key: 'Year:', value: tooltipModel.title[0] },
          { key: 'Donations: ', value:  this.api.formatCurrency(this.chartData[0].data[i] as number) },
          { key: 'Grants: ', value:  this.api.formatCurrency(this.chartData[1].data[i] as number) },
        ];
      }
    }
    setTimeout(()=>{this.ref.detectChanges();});
  }

}
